import * as actionTypes from '../types/shipment';

export function getShipment(payload) {
  return {
    type: actionTypes.GET_SHIPMENT,
    payload
  };
}

export function getShipmentSuccess(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_SUCCESS,
    payload
  };
}

export function getShipmentFail(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_FAIL,
    payload
  };
}

export function getShipmentCheckFIFO(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_CHECK_FIFO,
    payload
  };
}

export function getShipmentCheckFIFOSuccess(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_CHECK_FIFO_SUCCESS,
    payload
  };
}

export function getShipmentCheckFIFOFail(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_CHECK_FIFO_FAIL,
    payload
  };
}

export function getShipmentAccept(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_ACCEPT,
    payload
  };
}

export function getShipmentAcceptSuccess(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_ACCEPT_SUCCESS,
    payload
  };
}

export function getShipmentAcceptFail(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_ACCEPT_FAIL,
    payload
  };
}

export function getShipmentReject(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_REJECT,
    payload
  };
}

export function getShipmentRejectSuccess(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_REJECT_SUCCESS,
    payload
  };
}

export function getShipmentRejectFail(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_REJECT_FAIL,
    payload
  };
}

export function getShipmentConsignmentAccept(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_CONSIGNMENT_ACCEPT,
    payload
  };
}

export function getShipmentConsignmentAcceptSuccess(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_CONSIGNMENT_ACCEPT_SUCCESS,
    payload
  };
}

export function getShipmentConsignmentAcceptFail(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_CONSIGNMENT_ACCEPT_FAIL,
    payload
  };
}

export function getShipmentUpdate(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_UPDATE,
    payload
  };
}

export function getShipmentActRemoveMh3(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_ACT_REMOVE_MX3,
    payload
  };
}

export function getShipmentActRemoveMh3Success(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_ACT_REMOVE_MX3_SUCCESS,
    payload
  };
}

export function getShipmentActRemoveMh3Fail(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_ACT_REMOVE_MX3_FAIL,
    payload
  };
}

export function getShipmentActRemoveM15B(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_ACT_REMOVE_M15B,
    payload
  };
}

export function getShipmentActRemoveM15BSuccess(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_ACT_REMOVE_M15B_SUCCESS,
    payload
  };
}

export function getShipmentActRemoveM15BFail(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_ACT_REMOVE_M15B_FAIL,
    payload
  };
}

export function getShipmentErrorClear(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_ERROR_CLEAR,
    payload
  };
}

export function getShipmentClear(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_CLEAR,
    payload
  };
}

export function getShipmentReturnListCause(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_RETURN_LIST_CAUSE,
    payload
  };
}

export function getShipmentReturnListCauseSuccess(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_RETURN_LIST_CAUSE_SUCCESS,
    payload
  };
}
export function getShipmentReturnListCauseFail(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_RETURN_LIST_CAUSE_FAIL,
    payload
  };
}

export function getShipmentReturn(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_RETURN,
    payload
  };
}

export function getShipmentReturnSuccess(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_RETURN_SUCCESS,
    payload
  };
}
export function getShipmentReturnFail(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_RETURN_FAIL,
    payload
  };
}

export function getShipmentConsignmentClientsList(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_CONSIGNMENT_CLIENTS_LIST,
    payload
  };
}
export function getShipmentConsignmentClientsListSuccess(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_CONSIGNMENT_CLIENTS_LIST_SUCCESS,
    payload
  };
}
export function getShipmentConsignmentClientsListFail(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_CONSIGNMENT_CLIENTS_LIST_FAIL,
    payload
  };
}

export function getShipmentPlanContainerType(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_PLAN_CONTAINER_TYPE,
    payload
  };
}
export function getShipmentPlanContainerTypeSuccess(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_PLAN_CONTAINER_TYPE_SUCCESS,
    payload
  };
}
export function getShipmentPlanContainerTypeFail(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_PLAN_CONTAINER_TYPE_FAIL,
    payload
  };
}

export function getShipmentPlan(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_PLAN,
    payload
  };
}
export function getShipmentPlanSuccess(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_PLAN_SUCCESS,
    payload
  };
}
export function getShipmentPlanFail(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_PLAN_FAIL,
    payload
  };
}

export function getShipmentPlanCancel(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_PLAN_CANCEL,
    payload
  };
}
export function getShipmentPlanCancelSuccess(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_PLAN_CANCEL_SUCCESS,
    payload
  };
}
export function getShipmentPlanCancelFail(payload) {
  return {
    type: actionTypes.GET_SHIPMENT_PLAN_CANCEL_FAIL,
    payload
  };
}

export function getNextPlants(payload) {
  return {
    type: actionTypes.GET_NEXT_PLANTS,
    payload
  };
}
export function getNextPlantsSuccess(payload) {
  return {
    type: actionTypes.GET_NEXT_PLANTS_SUCCESS,
    payload
  };
}
export function getNextPlantsFail(payload) {
  return {
    type: actionTypes.GET_NEXT_PLANTS_FAIL,
    payload
  };
}

export function getNextPlant(payload) {
  return {
    type: actionTypes.GET_NEXT_PLANT,
    payload
  };
}
export function getNextPlantSuccess(payload) {
  return {
    type: actionTypes.GET_NEXT_PLANT_SUCCESS,
    payload
  };
}
export function getNextPlantFail(payload) {
  return {
    type: actionTypes.GET_NEXT_PLANT_FAIL,
    payload
  };
}

export function getSZList(payload) {
  return {
    type: actionTypes.GET_SZ_LIST,
    payload
  };
}
export function getSZListSuccess(payload) {
  return {
    type: actionTypes.GET_SZ_LIST_SUCCESS,
    payload
  };
}
export function getSZListFail(payload) {
  return {
    type: actionTypes.GET_SZ_LIST_FAIL,
    payload
  };
}
export function getSZListClear(payload) {
  return {
    type: actionTypes.GET_SZ_LIST_CLEAR,
    payload
  };
}

export function addItemsToReportOverdue(payload) {
  return {
    type: actionTypes.ADD_ITEMS_TO_REPORT_OVERDUE,
    payload
  };
}
export function addItemsToReportOverdueSuccess(payload) {
  return {
    type: actionTypes.ADD_ITEMS_TO_REPORT_OVERDUE_SUCCESS,
    payload
  };
}
export function addItemsToReportOverdueFail(payload) {
  return {
    type: actionTypes.ADD_ITEMS_TO_REPORT_OVERDUE_FAIL,
    payload
  };
}

export function updateSZ(payload) {
  return {
    type: actionTypes.UPDATE_SZ,
    payload
  };
}
export function updateSZSuccess(payload) {
  return {
    type: actionTypes.UPDATE_SZ_SUCCESS,
    payload
  };
}
export function updateSZFail(payload) {
  return {
    type: actionTypes.UPDATE_SZ_FAIL,
    payload
  };
}

export function setInitialStateShipment(payload) {
  return {
    type: actionTypes.SET_INITIAL_STATE_SHIPMENT,
    payload
  };
}

export function getSeparationsList(payload) {
  return {
    type: actionTypes.GET_SEPARATIONS_LIST,
    payload
  };
}

export function getSeparationsListSuccess(payload) {
  return {
    type: actionTypes.GET_SEPARATIONS_LIST_SUCCESS,
    payload
  };
}

export function getSeparationsListFail(payload) {
  return {
    type: actionTypes.GET_SEPARATIONS_LIST_FAIL,
    payload
  };
}

export function getSeparationsByPieces(payload) {
  return {
    type: actionTypes.GET_SEPARATIONS_BY_PIECES,
    payload
  };
}

export function getSeparationsByPiecesSuccess(payload) {
  return {
    type: actionTypes.GET_SEPARATIONS_BY_PIECES_SUCCESS,
    payload
  };
}

export function getSeparationsByPiecesFail() {
  return {
    type: actionTypes.GET_SEPARATIONS_BY_PIECES_FAIL
  };
}

export function getRollsPlacementTypes(payload) {
  return {
    type: actionTypes.GET_ROLLS_PLACEMENT_TYPES,
    payload
  };
}

export function getRollsPlacementTypesSuccess(payload) {
  return {
    type: actionTypes.GET_ROLLS_PLACEMENT_TYPES_SUCCESS,
    payload
  };
}

export function getRollsPlacementTypesFail() {
  return {
    type: actionTypes.GET_ROLLS_PLACEMENT_TYPES_FAIL
  };
}

export function addClientArrivalDate(payload) {
  return {
    type: actionTypes.ADD_CLIENT_ARRIVAL_DATE,
    payload
  };
}
export function addClientArrivalDateSuccess(payload) {
  return {
    type: actionTypes.ADD_CLIENT_ARRIVAL_DATE_SUCCESS,
    payload
  };
}
export function addClientArrivalDateFail(payload) {
  return {
    type: actionTypes.ADD_CLIENT_ARRIVAL_DATE_FAIL,
    payload
  };
}
